module.exports = __webpack_public_path__ + "static/img/2.04872fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/preview/pengu/2.png
// module id = bEO/
// module chunks = 35